const operationsColumns = {
  sequence: {
    key: 'sequence',
    label: 'sequence',
    type: 'text',
    minWidth: 80,
    sortable: false,
  },
  operation: {
    key: 'operation',
    label: 'operation',
    type: 'text',
    minWidth: 90,
    sortable: false,
  },
  containerType: {
    key: 'containerType',
    label: 'containerType',
    type: 'text',
    minWidth: 100,
    sortable: false,
  },
  containerCount: {
    key: 'containerCount',
    label: 'containerCount',
    type: 'text',
    minWidth: 90,
    sortable: false,
  },
  expectedValue: {
    key: 'expectedValue',
    label: 'expectedValue',
    type: 'text',
    minWidth: 90,
    sortable: false,
  },
  measure: {
    key: 'measure.description',
    label: 'measure',
    type: 'text',
    minWidth: 100,
    sortable: false,
  },
  symbol: {
    key: 'symbol',
    label: 'symbol',
    type: 'text',
    minWidth: 70,
    sortable: false,
  },
  symbolType: {
    key: 'symbolType',
    label: 'symbolType',
    type: 'enum',
    enum: 'symbolTypes',
    minWidth: 80,
    sortable: false,
  },
  LD: {
    key: 'LD',
    label: 'LD',
    type: 'text',
    minWidth: 40,
    sortable: false,
  },
  LQ: {
    key: 'LQ',
    label: 'LQ',
    type: 'text',
    minWidth: 40,
    sortable: false,
  },
  U: {
    key: 'U',
    label: 'U',
    type: 'text',
    minWidth: 40,
    sortable: false,
  },
  printOnWorksheet: {
    label: 'printOnWorksheet',
    type: 'boolean',
    minWidth: 110,
    fixed: true,
    sortable: false,
    align: 'center',
    emit: 'updatePrintOnWorksheet',
    permissions: ['operationsManage'],
  },
  printOnLabels: {
    label: 'printOnLabels',
    type: 'boolean',
    minWidth: 110,
    fixed: true,
    sortable: false,
    align: 'center',
    emit: 'updatePrintOnLabels',
    permissions: ['operationsManage'],
  },
  mainResult: {
    label: 'mainResult',
    type: 'boolean',
    minWidth: 110,
    fixed: true,
    sortable: false,
    align: 'center',
    emit: 'updateMainResult',
    permissions: ['operationsManage'],
  },
  recoveryFactor: {
    key: 'recoveryFactor',
    label: 'recoveryFactor',
    type: 'text',
    minWidth: 80,
    sortable: false,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    align: 'center',
    minWidth: 150,
    buttons: [
      {
        name: 'editOperation',
        icon: 'fas fa-pencil',
        permissions: ['operationsManage'],
      },
      {
        name: 'deleteOperation',
        icon: 'fas fa-trash-alt',
        permissions: ['operationsManage'],
      },
      {
        name: 'addCustomSpecification',
        icon: 'fas fa-pencil-ruler',
        permissions: ['operationsManage'],
      },
    ],
  },
};

export default operationsColumns;
